import React from 'react';
import { Text, View, Pressable } from 'react-native';
import { Connection } from '../~Utilities/Connection';
import { FontInfo, } from '../~Utilities/Constants';
import {StringTable} from '../StringTable';
import Utilities from '../~Utilities/Utilities';
import CxtStatus from '../C_Popups/CxtStatus';
import LED from '../C_Text/LED';
import OBNakedStaticStyleText from '../C_Text/OBNakedStaticStyleText';


/*   ====================================================================   */

interface IMessageRates
{
color:string;

bindEvent : (onEvent    : (() => void), 
             bSubscribe : boolean) => void;
}

/*   ====================================================================   */

export default class MessageRates extends React.Component<IMessageRates>
   {
   public static iMsgRate = 0;
   private       oCxtStatus : CxtStatus | null = null;

   /*   ------------------------------------------------------------------   */

   state = {data_visible:false};
   
   constructor(props)
   {
   super(props);

   this.state = {data_visible:false};
   }

   /*   ------------------------------------------------------------------   */

   render() 
   {
   if (!Connection.IsLoggedIn())  
      return(null);
   else
      return(
    <View style={{width:'100%', backgroundColor:"transparent", marginTop:4, marginLeft:0, alignSelf:"center", height:20}}>

      <View style={{width:'100%', alignItems:'center', flexDirection:'row', marginHorizontal:0, backgroundColor:"transparent", justifyContent:'center'}}>

          <Pressable style={{flexDirection:'row', marginLeft:-4, justifyContent:'center'}}
           onPress={()=>{this.oCxtStatus?.ShowModal()}}
            //onLongPress={()=>{  this.setState({data_visible:!this.state.data_visible})  }}
            >
          <OBNakedStaticStyleText bindEvent={this.props.bindEvent} 
                                  style={!this.state.data_visible? {display:'none'} :
                                  [FontInfo.appStyles.txt_normal, {marginRight:10, minWidth:50, 
                                  backgroundColor:'transparent',  textAlign:'left', color:this.props.color}]} 
                                  
                                  getText={()=>
                                  {
                                    return((Connection.oBytes/(1073741824.0)).toFixed(2) + "GB"  )
                                  }}/>

          <CxtStatus bindEvent={this.props.bindEvent} ref={node => { this.oCxtStatus = node; }}/>                                    

          {/* <Pressable style={{backgroundColor:'transparent', justifyContent:'center', flexDirection:'row'}} 
            onPress={()=>{this.oCxtStatus?.ShowModal()}}
            onLongPress={()=>{  this.setState({data_visible:!this.state.data_visible})  }}
            > */}

          <View style={{marginTop:1, marginLeft:0, alignSelf:'center', flexDirection:'column'}}>
            <View style={{flexDirection:'row', marginBottom:1}}>
              <LED bindEvent={this.props.bindEvent} 
                  getCxtState={Connection.GetMktState} 
                  style={{width:8, height:8, borderRadius:4, marginRight:1, alignSelf:'center'}}
                  />

              <LED bindEvent={this.props.bindEvent} 
                  getCxtState={Connection.GetHisState} 
                  style={{width:8, height:8, borderRadius:4,marginRight:1, alignSelf:'center'}}
                  />

              <LED bindEvent={this.props.bindEvent} 
                  getCxtState={Connection.GetOrdState} 
                  style={{width:8, height:8, borderRadius:4, marginRight:1, alignSelf:'center'}}
                  />

              <LED bindEvent={this.props.bindEvent} 
                  getCxtState={Connection.GetRMSState} 
                  style={{width:8, height:8, borderRadius:4,alignSelf:'center'}}
                  />

            </View>

            {/* <View style={{flexDirection:'row'}}> */}
              {/* <LED bindEvent={this.props.bindEvent} 
                  getCxtState={Connection.GetOrdState} 
                  style={{width:6, height:6, marginRight:3, borderRadius:2,alignSelf:'center'}}
                  />

              <LED bindEvent={this.props.bindEvent} 
                  getCxtState={Connection.GetRMSState} 
                  style={{width:6, height:6, borderRadius:3,alignSelf:'center'}}
                  /> */}
                  
            {/* </View> */}
            
          </View>

          {/* <OBNakedStaticStyleText bindEvent={this.props.bindEvent} 
                                  
                                  style={[FontInfo.appStyles.txt_normal, {alignSelf:'center', marginRight:0, minWidth:50, 
                                  backgroundColor:'transparent', textAlign:'left', textAlignVertical:'top', color:this.props.color}]} 
                                  
                                  onPress={()=>{this.oCxtStatus?.ShowModal()}}

                                  getText={()=>
                                          {
                                            return("" + MessageRates.iMsgRate)
                                          }}/> */}

          {/* </Pressable> */}
          
          {/* <OBNakedStaticStyleText bindEvent={this.props.bindEvent} 
                                  
                                  style={[FontInfo.appStyles.txt_normal, {alignSelf:'center', marginRight:0, minWidth:50, 
                                  backgroundColor:'transparent', textAlign:'left', textAlignVertical:'center', color:this.props.color}]} 
                                  
                                  onPress={()=>{this.oCxtStatus?.ShowModal()}}

                                  getText={()=>
                                          {
                                            return("" + MessageRates.iMsgRate)
                                          }}/> */}

          </Pressable>    

          <OBNakedStaticStyleText bindEvent={this.props.bindEvent} 
                                  
                                  style={[FontInfo.appStyles.txt_normal, {alignSelf:'center', marginRight:0, minWidth:30, 
                                  backgroundColor:'transparent', textAlign:'left', textAlignVertical:'center', color:this.props.color}]} 
                                  
                                  onPress={()=>{this.oCxtStatus?.ShowModal()}}

                                  getText={()=>
                                          {
                                            return("" + MessageRates.iMsgRate)
                                          }}/>

          <Text style={[FontInfo.appStyles.txt_normal, {marginRight:4, marginLeft:4,
                         backgroundColor:'transparent', textAlign:'right', minWidth:0, 
                         color:this.props.color}]}
                         onLongPress={()=>{  this.setState({data_visible:!this.state.data_visible})  }}
                         >v{StringTable.APP_VERSION}</Text> 

          <OBNakedStaticStyleText bindEvent={this.props.bindEvent} 
                                  style={[FontInfo.appStyles.txt_normal, {marginRight:0, minWidth:0, textAlign:'center', 
                                  backgroundColor:'transparent', color:this.props.color}]} 
                                  
                                  getText={()=>
                                          {
                                            return("" + Utilities.formatTimeStatusbar(Date.now()) + ""  )
                                          }}/>


      </View>
  
    </View>
   )}
}